import { IN_CA } from '../../utils/constants'

export const CAL_PLUS_FEATURES = {
  magicImport: {
    heading: 'Magic Import',
    text: `Turn emails, PDFs, and paper schedules into calendar events — instantly.`,
  },
  smartLists: {
    heading: 'Smart Lists',
    text: `Snap a photo of a list, or use your microphone to get organized in seconds.`,
  },
  mealPlanning: {
    heading: 'Smart Meals',
    text: `Import recipes and let Sidekick generate meal plans and grocery lists for you.`,
  },
}
export const PRODUCT_DROPDOWN_LABELS = {
  27: {
    label: `27" Calendar Max`,
  },
  15: {
    label: `15" Calendar`,
  },
  ...(IN_CA
    ? {}
    : {
        10: {
          label: `10" Calendar`,
        },
      }),
}

export const SPLIT_PRICE = {
  27: {
    Classic: '149.99',
    default: '157.49',
  },
  10: {
    default: '42.49',
  },
  15: {
    default: '74.99',
  },
}

export const CAL_PLUS_PRICING = {
  en: {
    10: {
      regularPrice: '159.99',
      withoutPlus: '119.99',
      withPlus: '109.99',
    },
    15: {
      regularPrice: '299.99',
      withoutPlus: '249.99',
      withPlus: '239.99',
    },
  },
  en_ca: {
    15: {
      regularPrice: '440.00',
      withoutPlus: '370.00',
      withPlus: '355.00',
    },
  },
  en_au: {
    15: {
      regularPrice: '499.00',
      withoutPlus: '399.00',
      withPlus: '379.00',
    },
  },
  en_gb: {
    15: {
      regularPrice: '280.00',
      regularPriceWithoutPlus: '290.00',
      withoutPlus: '246.50',
      withPlus: '238.00',
    },
  },
}
